import React, { Component } from 'react'
import { observer } from 'mobx-react';
import  humanizeDuration  from 'humanize-duration';
import UserStore from '../stores/UserStore';
import { FaBirthdayCake, FaRegCalendarAlt } from 'react-icons/fa';

@observer(['FamilyStore'])
class UpcomingBirthday extends Component {
    render() {      
        const theme = UserStore.theme();
        const familyStore = this.props.FamilyStore;
        const nextBirthdayDate = familyStore.nextBirthday ? new Date(familyStore.nextBirthday) : null;
        const primaryText = theme.font2 || '#ffffff';
        const secondaryText = 'rgba(255,255,255,0.9)';
        const chipText = theme.darkBackground || '#1f2d3d';
        const chipBg = 'rgba(255,255,255,0.88)';
        const bannerGradient = `linear-gradient(135deg, ${theme.header || '#1f4f6f'} 0%, ${theme.icons || '#1890ff'} 100%)`;

        return (
            <div style={{ padding: '18px 20px 8px 20px', textAlign: 'center' }}>
            <style>{`
                .birthday-banner-sheen {
                    position: absolute;
                    inset: 0;
                    pointer-events: none;
                    overflow: hidden;
                    border-radius: 16px;
                }

                .birthday-banner-sheen::before {
                    content: '';
                    position: absolute;
                    top: -35%;
                    left: -40%;
                    width: 38%;
                    height: 170%;
                    transform: rotate(16deg) translateX(-160%);
                    background: linear-gradient(
                        90deg,
                        rgba(255, 255, 255, 0) 0%,
                        rgba(255, 255, 255, 0.08) 40%,
                        rgba(255, 255, 255, 0.24) 50%,
                        rgba(255, 255, 255, 0.08) 60%,
                        rgba(255, 255, 255, 0) 100%
                    );
                    animation: birthday-banner-sheen 4.8s ease-in-out infinite;
                }

                @keyframes birthday-banner-sheen {
                    0% {
                        transform: rotate(16deg) translateX(-160%);
                    }
                    52% {
                        transform: rotate(16deg) translateX(360%);
                    }
                    100% {
                        transform: rotate(16deg) translateX(360%);
                    }
                }

                @media (prefers-reduced-motion: reduce) {
                    .birthday-banner-sheen::before {
                        animation: none;
                    }
                }
            `}</style>
            {familyStore.loaded ?
            familyStore.family.length > 0 ?
                <div style={{
                    position: 'relative',
                    borderRadius: '16px',
                    padding: '18px 18px 16px 18px',
                    boxShadow: '0 12px 28px rgba(15,23,42,0.18)',
                    background: bannerGradient,
                    color: primaryText,
                    border: '1px solid rgba(255,255,255,0.24)'
                }}>
                    <div className="birthday-banner-sheen" />
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 8 }}>
                        <FaBirthdayCake style={{ fontSize: '20px', color: primaryText }} />
                        <span className="AppFont BdayTitle" style={{ fontSize: 'clamp(18px, 2.2vw, 30px)', fontWeight: 700, lineHeight: 1.25 }}>
                            {familyStore.nextBirthdayName}'s birthday is in {humanizeDuration(familyStore.nextBirthday - Date.now(), { largest: 2, round: true })}
                        </span>
                    </div>

                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 8,
                        marginTop: 4,
                        padding: '8px 12px',
                        borderRadius: 999,
                        background: 'rgba(255,255,255,0.20)',
                        border: '1px solid rgba(255,255,255,0.35)'
                    }}>
                        <FaRegCalendarAlt style={{ color: secondaryText }} />
                        <div className="AppFont BdayTitleDate" style={{ fontSize: '15px', color: secondaryText, fontWeight: 600 }}>
                            {nextBirthdayDate ? nextBirthdayDate.toDateString() : ''}
                        </div>
                    </div>

                    {familyStore.bdaysUnder30.length > 0 ?
                        <div className="BdaySubtitle" style={{ marginTop: '14px' }}>
                            <span className="AppFont" style={{ fontWeight: 700, fontSize: '14px', color: primaryText, letterSpacing: '0.02em' }}>Also Coming Soon</span>
                            <div style={{ marginTop: 10, display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 8 }}>
                                {familyStore.bdaysUnder30.map((birthday) => (
                                    <div key={`${birthday.name}-${birthday.date}`} className="AppFont" style={{
                                        fontWeight: 700,
                                        fontSize: '13px',
                                        color: chipText,
                                        background: chipBg,
                                        border: `1px solid ${theme.icons || '#dbeafe'}`,
                                        borderRadius: 999,
                                        padding: '6px 10px'
                                    }}>
                                        {birthday.name}: {new Date(birthday.date).toLocaleDateString()}
                                    </div>
                                ))}
                            </div>
                        </div> : null}
                </div>
                : <div className="AppFont" style={{ fontWeight: 700, fontSize: '24px', color: theme.darkBackground || '#1f2937', marginTop: '8px' }}>No group members found</div>
                : <div className="AppFont" style={{ fontSize: '16px', color: theme.darkBackground || '#1f2937' }}>Loading upcoming birthdays...</div>}
            </div>
        )
    }
}

export default UpcomingBirthday;
